// extracted by mini-css-extract-plugin
export default {"root":"index__root--U4CtD","image":"index__image--D64YR"};